require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/fn/array/find.js
// module id = JO1o
// module chunks = 1